import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClientDataInitializerService } from 'src/app/core/services/authentication/client-data-initializer.service';
import { TranslationModule } from 'src/app/i18n';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';
import { SmsPreviewMobileComponent } from './mobile-preview/sms-preview-mobile.component';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
    selector: 'app-sms-preview',
    templateUrl: './sms-preview.component.html',
    imports: [
        CommonModule,
        SmsPreviewMobileComponent,
        TranslationModule,
        NgbModule,
        MaterialModule,
        ModalTitleComponent
    ],
    styleUrls: ['./sms-preview.component.scss']
})
export class SmsPreviewComponent implements OnInit {
  //#region Properties
  smsBody: string;
  senderNumber: number;
  agentLogo: string;
  selectedMode: any = 'ios';
  isImageLoad: boolean = false;

  //#endregion

  constructor(
    private dialogRef: MatDialogRef<SmsPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected elementRef: ElementRef,
    private clientDataService: ClientDataInitializerService
  ) {
    this.smsBody = data.finalSmsBody;
    this.senderNumber = data.privateNumber;
  }

  ngOnInit() {
    this.agentLogo = this.clientDataService.getCurrentClientData?.agentLogo;
  }

  onChangeMode(event) {
    this.selectedMode = event;
  }

  onClose() {
    this.dialogRef.close();
  }
}
